document.addEventListener(
"DOMContentLoaded",
function(){

    const btn=
    document.querySelector(
        ".order-art-btn"
    );


    if(!btn){
        return;
    }



    btn.addEventListener(
    "click",
    function(){


        const target=
        document.getElementById(
            "ai-size-builder-wrapper"
        );



        if(target){


            target.scrollIntoView({

                behavior:"smooth",

                block:"start"

            });


        }


    });


});